<template>
  <div v-if="!idProf" class="text-muted text-center py-10">
    Selecione um profissional para ver a agenda.
  </div>
  <div v-else-if="loading" class="text-center py-10">
    <span class="spinner-border text-primary"></span>
  </div>
  <div v-else class="sw-month">
    <div v-for="label in weekdayLabels" :key="label" class="sw-month__dow">{{ label }}</div>
    <div
      v-for="cell in cells"
      :key="cell.date"
      class="sw-month__cell"
      :class="{
        'is-muted': !cell.inMonth,
        'is-selected': cell.date === selectedDate,
        'is-today': cell.date === today,
      }"
      @click="$emit('select-day', cell.date)"
    >
      <div class="sw-month__day">
        <span>{{ cell.date.slice(-2) }}</span>
        <small v-if="countOn(cell.date)">{{ countOn(cell.date) }}</small>
      </div>
      <ScheduleAgendaItem
        v-for="item in previewOn(cell.date)"
        :key="item.id_sched || item.schedule_date_time"
        :schedule="item"
        @open="$emit('open-schedule', $event)"
      />
      <span v-if="extraOn(cell.date)" class="sw-month__more">+{{ extraOn(cell.date) }}</span>
    </div>
  </div>
</template>

<script>
import moment from '../../../helpers/date';
import { isPatientSchedule, schedulesOnDate, weekDays } from '../../../helpers/scheduleDay';
import ScheduleAgendaItem from './ScheduleAgendaItem.vue';

const PREVIEW = 3;

export default {
  name: 'ScheduleMonthGrid',
  components: { ScheduleAgendaItem },
  props: {
    cells: { type: Array, required: true },
    schedules: { type: Array, default: () => [] },
    selectedDate: { type: String, required: true },
    idProf: { default: null },
    loading: { type: Boolean, default: false },
  },
  emits: ['select-day', 'open-schedule'],
  computed: {
    today() {
      return moment().format('YYYY-MM-DD');
    },
    weekdayLabels() {
      return weekDays(this.selectedDate).map((day) => moment(day).format('ddd'));
    },
  },
  methods: {
    itemsOn(day) {
      return schedulesOnDate(this.schedules, day);
    },
    previewOn(day) {
      return this.itemsOn(day).slice(0, PREVIEW);
    },
    extraOn(day) {
      return Math.max(0, this.itemsOn(day).length - PREVIEW);
    },
    countOn(day) {
      return this.itemsOn(day).filter(isPatientSchedule).length;
    },
  },
};
</script>

<style scoped>
.sw-month {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0.4rem;
}
.sw-month__dow {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #a1a5b7;
  padding: 0 0.35rem;
}
.sw-month__cell {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
  min-height: 118px;
  padding: 0.4rem;
  border-radius: 0.55rem;
  background: #f9f9fb;
  cursor: pointer;
}
.sw-month__cell.is-muted {
  opacity: 0.45;
}
.sw-month__cell.is-selected {
  background: #f8f5f7;
  box-shadow: inset 0 0 0 1px #780f5a;
}
.sw-month__cell.is-today:not(.is-selected) {
  box-shadow: inset 0 0 0 1px #d8dbe6;
}
.sw-month__day {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.35rem;
  margin-bottom: 0.3rem;
  font-size: 0.92rem;
  font-weight: 800;
  color: #181c32;
}
.sw-month__day small {
  font-size: 0.75rem;
  font-weight: 700;
  color: #7e8299;
}
.sw-month__more {
  font-size: 0.75rem;
  font-weight: 700;
  color: #780f5a;
  padding: 0.1rem 0.2rem;
}
@media (max-width: 1199px) {
  .sw-month {
    overflow-x: auto;
    grid-template-columns: repeat(7, minmax(120px, 1fr));
  }
}
</style>
